import { computed } from "vue";
import type { ComputedRef, Ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useTeamsServiceListTeams } from "@/api/teams/teams";

/**
 * Derives the current user's roles in a given team from ListTeams (already
 * fetched app-wide, and it already includes members + roles) — no extra
 * request needed. Shared by AppSidebar (nav gating) and TeamView (manager
 * gate); both used to re-derive this identically.
 */
export function useMyRoles(teamId: Ref<string>): ComputedRef<string[]> {
  const auth = useAuthStore();
  const { data: teamsData } = useTeamsServiceListTeams();

  return computed(() => {
    const team = teamsData.value?.teams?.find((t) => t.id === teamId.value);
    return team?.members?.find((m) => m.id === auth.user?.id)?.roles ?? [];
  });
}
